import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import CampaignDetail from './CampaignDetail';

const goBackOr = (navigate, fallback) => {
  if (typeof window !== 'undefined' && window.history.length > 1) {
    navigate(-1);
    return;
  }
  navigate(fallback);
};

const CampaignDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    const campaignId = String(id || '').trim();
    if (!campaignId) {
      setCampaign(null);
      setError('Missing campaign id');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const snap = await getDoc(doc(db, 'campaigns', campaignId));
      if (!snap.exists()) {
        setCampaign(null);
        setError('Campaign not found');
        return;
      }
      setCampaign({ id: snap.id, ...snap.data() });
    } catch (e) {
      setCampaign(null);
      setError(e?.message || 'Failed to load campaign');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const close = () => goBackOr(navigate, '/campaigns');

  if (loading) {
    return (
      <div className="f-page-enter mx-auto max-w-4xl px-4 py-16 text-center text-slate-500">
        Loading campaign…
      </div>
    );
  }

  if (error || !campaign) {
    return (
      <div className="f-page-enter mx-auto max-w-4xl px-4 pb-8">
        <div className="f-card" style={{ padding: 40, textAlign: 'center' }}>
          <div style={{ color: '#d13438', marginBottom: 12 }}>{error || 'Campaign not found'}</div>
          <button type="button" className="f-button" onClick={() => navigate('/campaigns')}>
            View all campaigns
          </button>
        </div>
      </div>
    );
  }

  return <CampaignDetail campaign={campaign} onClose={close} />;
};

export default CampaignDetailPage;
